import { useCallback, useContext } from "react";
import { RemarkSubmissionData } from "../../models/remarks/RemarkSubmissionData";
import { RemarkSubmission } from "../../models/remarks/RemarkSubmission";
import { useWorkOrderStore } from "../../store/wo-order";
import { putPartial } from "../../api/Events";
import { appInsights } from "../../util/AppInsights";
import { TranslationMessagesContext } from "../../util/Translations";
import useGetWorkOrder from "../useGetWorkOrder";
import { formatCommentTimestamp } from "../../util/DateHelper";

export default function useSubmitNewComments() {
  const { translatedMessages } = useContext(TranslationMessagesContext);
  const { trigger } = useGetWorkOrder();
  const submitNewComments = useCallback(
    async (comment: string, woNumber: string) => {
      let workOrder = useWorkOrderStore.getState().getWorkOrderById(woNumber);
      if (!workOrder) {
        const woResponse = await trigger(woNumber);
        if (woResponse.status === 200) workOrder = woResponse.data;
      }
      const wDate = workOrder?.Events?.DateCreated;
      const wTime = workOrder?.Events?.TimeCreated;
      // US 922643: header time follows the user's 12/24-hour preference.
      const commentDate = formatCommentTimestamp();
      const commentSubmissionData = new RemarkSubmissionData(
        comment,
        commentDate
      );
      const submission = new RemarkSubmission(wDate, wTime);
      try {
        submission.Updates.push(commentSubmissionData);

        return await putPartial(submission);
      } catch (e) {
        appInsights?.trackEvent({
          name:
            translatedMessages["CommentSaveError"]?.MessageText ||
            "Error saving comment.",
          properties: {
            error: e,
            wDate: wDate,
            wTime: wTime,
            comment: submission,
          },
        });
      }
    },
    [translatedMessages, trigger]
  );

  return { submitNewComments };
}
